module.exports = __webpack_public_path__ + "static/media/POLOG_2026_PDF.586a413e.pdf";